import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class RestService {



  constructor(
    public http: HttpClient,
    public configProvider: ConfigService,
    public errorProvider: ErrorService
  ) { }


  post(obj: Object, route: string, method: string) {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
          'Access-Control-Allow-Headers':
            'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
        })
      }; 
      this.http.post(this.configProvider.getURLServe(route) + '/' + method, JSON.stringify(obj))
        .subscribe((result: any) => {
          resolve(result);
        },
          (error) => {
            this.errorProvider.erros(error.status);
            reject(error);
          });
    });
  }

  uploadFile(event, url: string) {
    return new Promise((resolve, reject) => {

      const formData = new FormData();

      Array.from(event[0].target.files).forEach((file: File) => formData.append('file[]', file, file.name));

      formData.append('data', JSON.stringify(event[1]));

      this.http.post(this.configProvider.URLServe + url, formData).subscribe((res) => {
        resolve(res);
      }, (err) => {
        console.log('err', err);
        reject(err);
      });

    });
  }
}
